import { READ_TIME_SEGMENT_KEY, createPageSegmentLoadMetric } from '@confluence/browser-metrics';
export const READ_TIME_METRIC = createPageSegmentLoadMetric({
	key: READ_TIME_SEGMENT_KEY,
});
